(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var items = (root || document).querySelectorAll('.vm-reveal:not(.vm-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      items.forEach(function (el) { el.classList.add('vm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('vm-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function initCompare(root) {
    (root || document).querySelectorAll('[data-vm-compare]').forEach(function (el) {
      if (el.dataset.vmInit) return;
      el.dataset.vmInit = '1';
      var range = el.querySelector('.vm-ba__range');
      if (!range) return;
      var touched = false;
      function set(v) { el.style.setProperty('--vm-pos', v + '%'); }
      range.addEventListener('input', function () { touched = true; set(range.value); });
      range.addEventListener('pointerdown', function () { touched = true; });
      if (reduce || !('IntersectionObserver' in window)) { set(50); return; }
      range.value = 90;
      set(90);
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var start = performance.now();
        var from = 90, to = 50, dur = 1500;
        (function tick(now) {
          if (touched) return;
          var t = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - t, 3);
          var v = from + (to - from) * eased;
          range.value = v;
          set(v);
          if (t < 1) requestAnimationFrame(tick);
        })(start);
      }, { threshold: 0.55 });
      io.observe(el);
    });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('[data-vm-gallery]').forEach(function (g) {
      if (g.dataset.vmInit) return;
      g.dataset.vmInit = '1';
      var track = g.querySelector('.vm-gallery__track');
      var slides = Array.prototype.slice.call(g.querySelectorAll('.vm-gallery__slide'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.vm-thumb'));
      if (!track || !slides.length) return;
      var current = 0;
      function setActive(i) {
        current = i;
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        setActive(i);
      }
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
      var prev = g.querySelector('[data-vm-prev]');
      var next = g.querySelector('[data-vm-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) setActive(i);
        });
      }, { passive: true });
      g._vmGo = go;
      g._vmSlides = slides;
      setActive(0);
    });
  }

  function initPdp(root) {
    (root || document).querySelectorAll('[data-vm-pdp]').forEach(function (el) {
      if (el.dataset.vmInit) return;
      el.dataset.vmInit = '1';
      var dataEl = el.querySelector('[data-vm-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = el.querySelector('.product-variant-id');
      var btn = el.querySelector('.product-form__submit');
      var btnText = btn ? btn.querySelector('span') : null;
      var priceEl = el.querySelector('[data-vm-price]');
      var compareEl = el.querySelector('[data-vm-compare-price]');
      var saleEl = el.querySelector('[data-vm-sale]');
      var showCompare = el.dataset.showCompare === 'true';
      var strings = { add: el.dataset.addLabel || 'Add to cart', soldOut: el.dataset.soldLabel || 'Sold out' };
      var currency = el.dataset.currency || 'USD';
      var fmt;
      try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }); } catch (e) { fmt = null; }
      function money(c) { return fmt ? fmt.format(c / 100) : (c / 100).toFixed(2); }

      var state = variants[0].options.slice();
      var checked = variants.filter(function (v) { return v.id === Number(idInput && idInput.value); })[0];
      if (checked) state = checked.options.slice();

      function match() {
        return variants.filter(function (v) { return v.options.every(function (o, i) { return o === state[i]; }); })[0];
      }
      function apply(v) {
        if (!v) {
          if (btn) { btn.setAttribute('disabled', 'disabled'); if (btnText) btnText.textContent = el.dataset.unavailableLabel || 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) {
          var show = showCompare && v.compare_at_price && v.compare_at_price > v.price;
          compareEl.hidden = !show;
          if (show) compareEl.textContent = money(v.compare_at_price);
          if (saleEl) saleEl.hidden = !show;
        }
        if (btn) {
          if (v.available) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); if (btnText) btnText.textContent = strings.add; }
          else { btn.setAttribute('disabled', 'disabled'); if (btnText) btnText.textContent = strings.soldOut; }
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        var g = document.querySelector('[data-vm-gallery]');
        if (g && g._vmGo && v.featured_media) {
          var mid = String(v.featured_media.id);
          g._vmSlides.forEach(function (s, i) { if (s.dataset.mediaId === mid) g._vmGo(i); });
        }
      }
      el.querySelectorAll('.vm-opt').forEach(function (fs) {
        var idx = Number(fs.dataset.optionIndex);
        var label = fs.querySelector('[data-vm-opt-label]');
        fs.querySelectorAll('input[type=radio]').forEach(function (r) {
          r.addEventListener('change', function () {
            state[idx] = r.value;
            if (label) label.textContent = r.dataset.label || r.value;
            apply(match());
          });
        });
      });
      var qty = el.querySelector('.vm-qty input');
      if (qty) {
        el.querySelectorAll('.vm-qty button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(qty.value, 10) || 1;
            n += b.dataset.step === 'up' ? 1 : -1;
            qty.value = Math.max(1, n);
          });
        });
      }
    });
  }


  function initSticky(root) {
    (root || document).querySelectorAll('[data-vm-sticky]').forEach(function (bar) {
      if (bar.dataset.vmInit) return;
      bar.dataset.vmInit = '1';
      var hero = document.querySelector('.vm-hero-pdp');
      var heroBtn = hero && hero.querySelector('[data-vm-add]');
      var btn = bar.querySelector('[data-vm-sticky-btn]');
      var fin = document.querySelector('[data-vm-final-buy]');
      if (!heroBtn || !btn) return;
      btn.addEventListener('click', function () { if (!heroBtn.disabled) heroBtn.click(); });
      var ticking = false;
      function update() {
        ticking = false;
        var vh = window.innerHeight;
        var h = heroBtn.getBoundingClientRect();
        var heroVisible = h.bottom > 0 && h.top < vh;
        var past = fin ? fin.getBoundingClientRect().top < vh * 0.85 : false;
        var show = !heroVisible && !past && !heroBtn.disabled;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }

  function initAll(root) {
    initReveal(root);
    initCompare(root);
    initGallery(root);
    initPdp(root);
    initSticky(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
